import type { FlowConfigData, FlowStep } from '../types/flowConfig.types'

export type UpdateFlowStepResult =
  | {
      config: FlowConfigData
      /** Quando o ID do passo foi alterado, o novo id (para manter o inspetor/seleção). */
      renamedTo?: string
    }
  | null

/**
 * Atualiza um passo no mapa `steps`, incluindo renomear a chave do passo quando `updates.id` difere de `stepId`.
 */
export function updateFlowStepInConfig(
  prev: FlowConfigData,
  stepId: string,
  updates: Partial<FlowStep>
): UpdateFlowStepResult {
  const currentStep = prev.steps?.[stepId]
  if (!currentStep) {
    return null
  }

  if (updates.id !== undefined && updates.id !== stepId) {
    const newId = updates.id.trim()
    if (!newId) {
      window.alert('ID da etapa não pode ser vazio.')
      return null
    }

    if (prev.steps[newId]) {
      window.alert('Já existe uma etapa com esse ID. Use um ID único.')
      return null
    }

    const renamedStep: FlowStep = {
      ...currentStep,
      ...updates,
      id: newId
    }

    const newSteps: Record<string, FlowStep> = {}
    Object.entries(prev.steps).forEach(([key, value]) => {
      if (key === stepId) {
        newSteps[newId] = renamedStep
      } else {
        newSteps[key] = value
      }
    })

    return {
      config: {
        ...prev,
        steps: newSteps,
        start_step: prev.start_step === stepId ? newId : prev.start_step
      },
      renamedTo: newId
    }
  }

  return {
    config: {
      ...prev,
      steps: {
        ...prev.steps,
        [stepId]: {
          ...currentStep,
          ...updates
        }
      }
    }
  }
}
